var trustlogosInterval,
	currentTrustlogo = 1,
	trustlogosContainer = document.querySelector('.trustlogos-list'),
	autoSlideTrustlogos = function() {
		var firstTrustlogo = trustlogosContainer.querySelector('li'),
			trustlogoWidth = firstTrustlogo.offsetWidth;

		if(firstTrustlogo.getBoundingClientRect().right < 0) {
			trustlogosContainer.appendChild(firstTrustlogo);
			trustlogosContainer.scrollTo(trustlogosContainer.scrollLeft - (trustlogoWidth + 80), 0);
			currentTrustlogo = 2;
		}

		Velocity(trustlogosContainer.querySelector('li:nth-child('+(++currentTrustlogo)+')'), 'scroll', {container: trustlogosContainer, axis: 'x', offset: -((window.innerWidth - trustlogoWidth) / 2)});
	};

var trustlogosWaypoint = new Waypoint({
    element: trustlogosContainer,
    handler: function(direction) {
        setTrustlogosInterval();
    },
    offset: '100%'
});

window.addEventListener('resize', setTrustlogosInterval);

function setTrustlogosInterval() {
	currentTrustlogo = 1;
	clearInterval(trustlogosInterval);

	if(checkWidth(480) && trustlogosContainer.getBoundingClientRect().top < window.innerHeight)
		trustlogosInterval = setInterval(autoSlideTrustlogos, 2000);
}